import schedule from './schedule.vue'

export default schedule
